import { render, staticRenderFns } from "./TicketItems.vue?vue&type=template&id=aa66621e&scoped=true&"
import script from "./TicketItems.vue?vue&type=script&lang=ts&"
export * from "./TicketItems.vue?vue&type=script&lang=ts&"
import style0 from "./TicketItems.vue?vue&type=style&index=0&id=aa66621e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa66621e",
  null
  
)

export default component.exports